module.exports = __webpack_public_path__ + "img/Bezuidenhoutseweg na.4a01e52e.jpg";